<template>
  <!-- Rendered instead of the page sections while the tenant has switched the
       public site offline (tenant-config `offline: true`). Like
       AnnouncementModal this is deliberately palette-independent: the card and
       every piece of text in it use the fixed --off-* locals below, never
       surface.* / text.* / brand.*, so an operational notice stays legible on
       any tenant palette. Only the page background around the card follows
       the theme. The owner's message is rendered as plain text (no v-html);
       `white-space: pre-line` keeps their line breaks. -->
  <section id="home" class="offline" aria-labelledby="offline-title">
    <div class="offline-card" role="status">
      <p v-if="businessName" class="offline-studio">{{ businessName }}</p>
      <h1 id="offline-title" class="offline-title">{{ $t('offline.title') }}</h1>
      <p class="offline-body">{{ $t('offline.body') }}</p>
      <p v-if="message" class="offline-message">{{ message }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OfflinePage',
  props: {
    businessName: {
      type: String,
      default: ''
    },
    // The owner's free-text notice from tenant-config `offlineMessage` (already trimmed by App.vue).
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Fixed, palette-independent locals (same values as AnnouncementModal's --ann-*):
   ink 15.8:1 on the white card, 14.6:1 on the paper message panel; muted 5.8:1. */
.offline {
  --off-surface: #FFFFFF;
  --off-paper: #F7F6F3;
  --off-ink: #1F2328;
  --off-muted: #5C6166;
  --off-hairline: #E3E0DA;

  display: flex;
  align-items: center;
  justify-content: center;
  /* Tall enough that the footer sits below the fold on phones. */
  min-height: 70vh;
  min-height: 70dvh;
  padding: var(--s-7) 16px;
}

.offline-card {
  width: 100%;
  max-width: 560px;
  padding: var(--s-6) var(--s-5);
  background: var(--off-surface);
  color: var(--off-ink);
  border-radius: var(--r-3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  text-align: center;
}

.offline-studio {
  margin-bottom: var(--s-3);
  color: var(--off-muted);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  overflow-wrap: anywhere;
}

.offline-title {
  margin-bottom: var(--s-4);
  color: var(--off-ink);
  font-size: var(--fs-h2);
  line-height: 1.2;
}

.offline-body {
  color: var(--off-ink);
  font-size: var(--fs-body);
  line-height: 1.6;
}

.offline-message {
  margin-top: var(--s-5);
  padding: var(--s-4);
  background: var(--off-paper);
  border: 1px solid var(--off-hairline);
  border-radius: var(--r-2);
  color: var(--off-ink);
  font-size: var(--fs-body);
  line-height: 1.6;
  text-align: left;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

@media (min-width: 768px) {
  .offline {
    padding: var(--s-8) var(--gutter);
  }

  .offline-card {
    padding: var(--s-7) var(--s-6);
  }
}
</style>
